module.exports = __webpack_public_path__ + "img/eat_out_14.5e883161.jpg";